var $ = require('jquery');
var slick = require('slick-carousel');

module.exports = {
	init: function () {
		var slider = $('.layout.testimonials .testimonials-list-inner');
		if (slider.length > 0) {
			for (var i = 0; i < slider.length; i++) {
				var $currentSlider = $(slider[i]);
				var $sliderContainer = $currentSlider.closest('.testimonials-list-inner');
				var $slideCounter = $sliderContainer.find('.main-testimonial').length;
				var showArrows = $slideCounter > 1;
				var prevArrow = showArrows ? $sliderContainer.parent().find('.slick-prev') : null;
				var nextArrow = showArrows ? $sliderContainer.parent().find('.slick-next') : null;
				// Determine slides to show based on grid class
				var slidesToShow = 1; // Default

				// remove slider controls if only one slide
				if (!showArrows) {
					$sliderContainer.parent().find('.slider-controls').remove();
				}

				// Init slider with responsive settings
				$currentSlider.slick({
					dots: true,
					infinite: false,
					arrows: showArrows,
					fade: true,
					speed: 300,
					slidesToShow: slidesToShow,
					slidesToScroll: 1,
					draggable: false,
					swipeToSlide: true,
					touchThreshold: 10,
					appendDots: $sliderContainer.parent().find('.slick-dots-wrapper'),
					prevArrow: prevArrow,
					nextArrow: nextArrow,
				});
			}
		}
	},
};
